import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SubstitutionBoard } from '../../interfaces/interfaces.module';
import { SubBoardHttpClient } from '../../shared/shared.module';

@Injectable({
    providedIn: 'root'
})
export class PrivilegesApiService {
    constructor(private http: SubBoardHttpClient) {}

    public get(): Observable<SubstitutionBoard.SubstitutionBoardPrivileges> {
        return this.http.get<SubstitutionBoard.SubstitutionBoardPrivileges>('privileges', false);
    }
}
